import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { toggleSwitch,
        popUpMessageChange,
        editCards, 
        editFeaturesGroup, 
        editFigures, 
        selectedCardsGroupsChange} from '../../actions/index.js';

import { _ } from '../../functions/translator.js';

import { Button } from '@material-ui/core';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import SendIcon from '@material-ui/icons/Send';

import { postData } from '../../functions/postData.js';
import { reloadCardsGroupsFeatures } from '../../functions/map/reloadCardsGroups.js';
import { showMessage } from '../../functions/popUpMessage.js';
import { ToggleActions } from '../../constants/constants.js';
import { getAvailableValuesFromAttributes } from '../../functions/getter.js';

class ChangeLevel extends React.Component{

    constructor(props) {
        super(props)
        this.state = {
            levelId: 0,
        }
    }

    handleOnClick = async () => {
        const message =  _('Cambiando Piso') + '...';
        showMessage(this.props, message, { loading: true });
        let urlPost = {
            project_id: window.project_id,
            level_id: this.state.levelId, 
            cards_group_ids: this.props.selectedCardsGroups,
        }
        let cardsGroupIds = [...this.props.selectedCardsGroups];
        this.handleClose();
        const levelIdsToReload = getAvailableValuesFromAttributes(
            this.props.projectData.cards_groups,
            'level_id',
            this.props.selectedCardsGroups
        );
        let response = await postData('/web-api/change-cards-groups-level', urlPost);
        this.handleResponse(response, cardsGroupIds, levelIdsToReload);
    }

    handleClose = () => {
        this.props.toggleSwitch(ToggleActions.CHANGE_LEVEL_COMPONENT, false);
        this.props.selectedCardsGroupsChange([]);
    }

    handleResponse = (response, cardsGroupIds, levelIdsToReload) => {
        const success = response.status === 'success';
        const message = success ? '¡' + _('Piso cambiado exitosamente') + '!' : _('Ocurrió un error, no se pudo cambiar el Piso') + '.';
        showMessage(this.props, message);
        if (success) {
            const ignoreIds = [];
            reloadCardsGroupsFeatures(this.props, cardsGroupIds, ignoreIds, levelIdsToReload);
        }
    }

    handleLevelChange = (event) => {
        this.setState({ levelId: event.target.value });
    };


    render(){
        const options = []
        for (const [key, levelData] of Object.entries(this.props.projectData.levels)) {
            const stageId = levelData.attributes.stage_id;
            const stageName = this.props.projectData.stages[stageId]?.attributes.name;
            const levelFullName = `${stageName} - ${levelData.attributes.name}`;
            options.push(
                <MenuItem value={levelData.id} key={key}>
                    {levelFullName}
                </MenuItem>
            )
            
        }
        return (
            <div>
                { this.props.changeLevel ? (
                    <div>
                        <div className='sensitive-background' onClick={this.handleClose}></div>
                        <div className="add-progress-card-layout card-color">
                            <h4 className='text-center'>{ _('Cambiar Piso') }</h4>
                            <div className='my-4'>
                                <Select
                                value={this.state.levelId}
                                onChange={this.handleLevelChange}>
                                {options}
                                </Select>
                            </div>
                            <div className='d-flex justify-content-center'>
                                <Button variant="contained" onClick={this.handleOnClick} className='success-button'>
                                    <SendIcon/>
                                    <span style={{ paddingLeft: 10 }}>{ _('Cambiar')}</span>
                                </Button>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div></div>
                )}
            </div>
        )
    }
}

function mapStateToProps( state ){
    return {
        projectData         : state.projectData,
        changeLevel         : state.switches.changeLevel,
        selectedCardsGroups : state.selectedCardsGroups,
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({ 
        toggleSwitch : toggleSwitch,
        selectedCardsGroupsChange : selectedCardsGroupsChange,
        popUpMessageChange : popUpMessageChange,
        editFeaturesGroup : editFeaturesGroup,
        editCards : editCards,
        editFigures : editFigures
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(ChangeLevel)